module.exports = __webpack_public_path__ + "static/js/refresh.25fdf2a9.chunk.worker.js"